<template>
    <div>
        <div id="banner" class="block-banner hideBanner">
            <ejs-button class='expandButton' v-if="showExpandButton !== false" v-on:click.native="expandClick"></ejs-button>
            <ejs-splitter ref='splitter' orientation = 'Vertical' width='98%' height='auto' :beforeCollapse='beforeCollapse' :beforeExpand='beforeExpand' :imgBanner='imgBanner'>
                <e-panes>
                    <e-pane :content ='content1' size ='auto' :collapsible=true min='100%' max='100%' :resizable ='resize'></e-pane>
                </e-panes>
            </ejs-splitter>
        </div>
    </div>
</template>

<script>
import { SplitterPlugin } from '@syncfusion/ej2-vue-layouts';
import axios from 'axios';
Vue.use(SplitterPlugin);

var contentVue1 = Vue.component("contentTemp1", {
    template: `<div class="content">
                    <img v-bind:src='imgBanner' class="img-fluid" style="margin: 0 auto; display: block; width: auto; height: auto;">
                </div>`,
    data() {
        return {
            data: {},
            imgBanner : ''
        };
    },
    methods: {
        getImgBanner: function (args){
            if(this.$parent.$attrs.imgBanner !== "")
            {
                this.$store.commit('moduleAvatar/SET_B64_LOGO', this.$parent.$attrs.imgBanner);
                this.imgBanner = this.$parent.$attrs.imgBanner;
            }
        }
    },
    created: function (){
        this.getImgBanner();
    }
});

var contentVue2 = Vue.component("contentTemp2", {
    template: `<div class="content"></div>`,
    data() {
        return {
            data: {}
        };
    }
});

export default {
    name: 'banner',
    data () {
        return {
            content1: function (){
                return { template: contentVue1 }
            },
            content2: function (){
                return { template: contentVue2 }
            },
            resize: false,
            showExpandButton: false,
        }
    },
    props: {
        imgBanner: {default: ''}
    },
    methods: {
        beforeCollapse : function(args){
            args.element.style.height = '0px';
            args.element.style.top = '-21px';
            this.showExpandButton = true;
        },
        beforeExpand : function(args){
            args.element.style.height = '112px';
            args.element.style.top = '0px';
        },
        expandClick : function() {
            this.$refs.splitter.expand(0);
            this.showExpandButton = false;
        },
    },
}
</script>